<template>
    <div>
        <v-toolbar dark dense>
            <v-toolbar-title>Mineit Service</v-toolbar-title>

            <v-spacer></v-spacer>
            <v-toolbar-items>
                <v-btn class="elevation-0" activeClass="info" to="/computers">Monitor</v-btn>
                <v-btn class="elevation-0" activeClass="info" to="gpus">Gpus</v-btn>
                <v-btn class="elevation-0" activeClass="info" to="service">Service</v-btn>
            </v-toolbar-items>
        </v-toolbar>
        <div class="page_wrap_vue pa-1">
            <transition name="fade">
                <router-view></router-view>
            </transition>
        </div>
        <v-dialog v-if="showModal" :max-width="modalWidth" persistent ref="modal" v-model="showModal"
                  :transition="modalTransition">
            <router-view name="dialog"></router-view>
        </v-dialog>
    </div>
</template>

<script>
    export default {
        props: {
            label: {
                type: String,
                default: 'No label',
            },
            modalPersistent: {
                type: Boolean,
                default: true,
            },
            modalTransition: {
                type: String,
                default: 'slide-y-reverse-transition',
            },
            modalWidth: {
                default: 840,
            }
        },
        data() {
            return {
                showModal: this.$route.meta.showModal,
            }
        },
        mounted() {
            this.$eventBus.$on(['MODAL_CLOSE'], (route) => {
                this.close(route);
            });
        },
        methods: {
            close(route = null) {
                if (route)
                    this.$router.push(route);
            }
        },
        watch: {
            '$route.meta'({showModal}) {
                this.showModal = showModal
            }
        }
    }
</script>

